import { render } from "./JournalTile.vue?vue&type=template&id=667eb334&scoped=true"
import script from "./JournalTile.vue?vue&type=script&lang=js"
export * from "./JournalTile.vue?vue&type=script&lang=js"

import "./JournalTile.vue?vue&type=style&index=0&id=667eb334&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-667eb334"]])

export default __exports__